import { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';
import { isValid, format } from 'date-fns';

import { AppState } from 'services/types';
import {
    VirtualizedTableItemValue,
    VirtualizedTableProps
} from 'services/virtualizedTable/types';
import {
    makeSelectVirtualizedTableItemValue,
    makeSelectVirtualizedTableColumnFieldValue
} from 'services/virtualizedTable/selectors';

type OwnProps = VirtualizedTableProps;

export interface ConnectedProps {
    itemValue?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableItemValue>
    >;
    dateFormat?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableColumnFieldValue>
    >;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableDateValueComponent = (
    props: Props
): VirtualizedTableItemValue | null => {
    const { itemValue, dateFormat } = props;
    let result = null;

    if (itemValue) {
        const date = new Date(itemValue);

        if (isValid(date)) {
            result = format(date, dateFormat || 'dd/MM/yyyy');
        }
    }

    return result;
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    itemValue: makeSelectVirtualizedTableItemValue(),
    dateFormat: makeSelectVirtualizedTableColumnFieldValue('dateFormat')
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableDateValueComponent, isEqual)
);
